import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, ElementRef, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'artemis-dropdown-menu',
  templateUrl: './dropdown-menu.component.html',
  styleUrls: ['./dropdown-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownMenuComponent implements OnInit {

  dropdownOpened: boolean = false;

  @Output() toggle: EventEmitter<boolean> = new EventEmitter();

  constructor(private cdRef: ChangeDetectorRef,
              public elRef: ElementRef) { }

  ngOnInit() {
  }

  toggleDropdown(newValue?: boolean): void {
    this.dropdownOpened = newValue === false || newValue === true ? newValue : !this.dropdownOpened;
    this.toggle.next(this.dropdownOpened);
    this.cdRef.detectChanges();
  }
}
